var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "mt-4 mb-2", attrs: { "justify-center": "" } },
    [
      true
        ? _c("v-card", { staticClass: "terms1 text-xs-center pb-4" }, [
            _c("i", { staticClass: "icon-ic-check" }),
            _c(
              "div",
              [
                _c("h2", [_vm._v("¡Listo!")]),
                _c(
                  "span",
                  { staticClass: "pt-3 d-block" },
                  [
                    _c(
                      "v-layout",
                      { staticClass: "text-xs-center" },
                      [
                        _c("v-flex", [
                          _vm._v(
                            "Los comercios ya se encuentran afiliados a Niubiz"
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("span", { staticClass: "pt-3 d-block" }),
                _c(
                  "v-layout",
                  { staticClass: "text-xs-left" },
                  [
                    _c("v-flex", [_vm._v("Afiliaciones concretadas   ")]),
                    _c("v-flex", { staticClass: "text-xs-right" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.infoTable.countWorked))])
                    ])
                  ],
                  1
                ),
                _vm.infoTable.countNotWorked > 0
                  ? _c(
                      "v-layout",
                      { staticClass: "text-xs-left" },
                      [
                        _c("v-flex", [
                          _vm._v("Afiliaciones no concretadas   ")
                        ]),
                        _c("v-flex", { staticClass: "text-xs-right" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.infoTable.countNotWorked))
                          ])
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.infoTable.countInHold > 0
                  ? _c(
                      "v-layout",
                      { staticClass: "text-xs-left" },
                      [
                        _c("v-flex", [_vm._v("Afiliaciones en espera   ")]),
                        _c("v-flex", { staticClass: "text-xs-right" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.infoTable.countInHold))
                          ])
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "div-table" },
              [
                _c("span", { staticClass: "pt-3 d-block" }),
                _c("v-data-table", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.dataTable,
                    pagination: _vm.pagination,
                    "actions-prepend": "",
                    id: "modify-case"
                  },
                  on: {
                    "update:pagination": function($event) {
                      _vm.pagination = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "headers",
                      fn: function(props) {
                        return [
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "slide__item-row text-xs-left" },
                              [_vm._v(_vm._s(props.headers[0].text))]
                            ),
                            _c(
                              "th",
                              { staticClass: "slide__item-row text-xs-left" },
                              [_vm._v(_vm._s(props.headers[1].text))]
                            ),
                            _c(
                              "th",
                              { staticClass: "slide__item-row text-xs-left" },
                              [_vm._v(_vm._s(props.headers[2].text))]
                            ),
                            _c(
                              "th",
                              { staticClass: "slide__item-row text-xs-left" },
                              [_vm._v(_vm._s(props.headers[3].text))]
                            )
                          ])
                        ]
                      }
                    },
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c("tr", { staticClass: "slide__item-content" }, [
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.name))
                            ]),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.direccion.toUpperCase()))
                            ]),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.moneda.toUpperCase()))
                            ]),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.codigo))
                            ])
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _c("span", { staticClass: "pt-3 d-block" }),
                _c(
                  "v-btn",
                  {
                    staticClass: "primary-button",
                    on: { click: _vm.returnDashboard }
                  },
                  [_vm._v("Aceptar")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _c("loader", {
        ref: "loaderModal",
        attrs: { text: "Enviando Correo ..." }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56c84cab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c84cab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/terms-multiAdress.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-56c84cab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/terms-multiAdress.vue
// module chunks = 0 1 2 3